<template>
  <div v-if="isVisible" :class="$style.modal__overlay" @click="closeOnOverlayClick">
    <div :class="$style.modal" @click.stop>

      <div :class="$style.modal__header">
        <h3>{{ title }}</h3>
        <button :class="$style.modal__close" @click="emitClose">&times;</button>
      </div>

      <div :class="$style.modal__body">
        <slot></slot>
      </div>

      <div v-if="$slots.footer" :class="$style.modal__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    isVisible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    closeOnOverlay: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['close']);

  const emitClose = () => {
    emit('close');
  };

  const closeOnOverlayClick = () => {
    if (props.closeOnOverlay) {
      emitClose();
    }
  };
</script>

<style module lang="scss">

  .modal {
    width: 100%;
    max-width: 500px;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    background-color: rgba(45, 45, 45, 0.9);

    @include respond-to(null, 'xs') {
      max-width: 300px;
    }

    &__overlay {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      display: flex;
      position: fixed;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.8);
    }

    &__header {
      display: flex;
      padding: 16px;
      align-items: center;
      justify-content: space-between;
    }

    &__header h3 {
      margin: 0;
      color: #fff;
      font-size: 18px;
    }

    &__close {
      color: #FFF;
      border: none;
      font-size: 24px;
      cursor: pointer;
      background: none;
    }

    &__body {
      padding: 16px;
      color: #dcdcdc;
    }

    &__footer {
      padding: 16px;
      text-align: right;
    }
  }

</style>
